// extracted by mini-css-extract-plugin
export default {"summary":"P4aEE8QJmLvvYBZCEH_g","separator":"IEgiqLCq1AU44sIBIxit"};